<template>
  <span class="checkbox-wrapper">
    <span v-if="options" class="checkbox-container" :style="outerWidth">
      <span v-for="(data, index) in options" :key="index" class="checkbox-inner" :style="innerWidth">
        <label class="checkbox-label" :class="additionalCss">
          <input type="checkbox" :value="data.value" class="checkbox" v-model="checked" :disabled="isDisable">
          <i v-if="checkStatus(data.value)" class="fas fa-check-square checkbox-icon-checked" :class="sizeType"></i>
          <i v-else class="fas fa-square checkbox-icon-none" :class="sizeType"></i>
          <span class="label" :class="sizeTypeLabel">
            <div v-if="data.label2" class="inner-label-2row">{{data.label}}<br>{{data.label2}}</div>
            <div v-else>{{data.label}}</div>
          </span>
        </label>
      </span>
    </span>
  </span>
</template>

<script>

/**
 *
 * name: フォーム名
 * options データ
 * size サイズ(任意)
 * labelSize サイズ(任意)
 * outerSize 任意(px)
 * innerSize 任意(px)
 * isDisable 編集不可 bool
 *
 */
export default {
  props: ['name', 'options', 'default', 'size', 'labelSize', 'outerSize', 'innerSize', 'isDisable'],
  data () {
    return {
      checked: [],
      watchCtrlA: null,
      watchCtrlFV: null
    };
  },
  created: function () {
  },
  mounted: function () {
    this.initialize();
  },
  beforeUpdate: function () {
    // console.log('beforeUpdate', this.name)
    this.updated();
  },
  updated: function () {
  },
  destroyed: function () {

    // 初期化
    this.watchCtrlA();
    this.watchCtrlFV();
  },
  watch: {
    '$route' () {
      // ルートの変更の検知
      this.initialize();
    },
    checked: function () {
      // console.log(this.name, this.checked);

      let value = {key: this.name, value: this.checked, call: 'CheckBoxObject:watch:checked'};
      this.$store.dispatch('formValues/setFormData', value).then();

      this.$emit('callback', this.name, this.checked);

    },
    options: function () {
      console.log('watch::options');
      this.initialize();
    },
    default:function () {
      console.log('watch::default');
      this.initialize();
    }
  },
  computed: {
    sizeType: function () {
      if (this.size === 'ss') {
        return 'size-ss';
      } else if (this.size === 's') {
        return 'size-s';
      } else {
        return 'size-m';
      }
    },
    sizeTypeLabel: function () {
      // labelSizeが指定されていない場合は mサイズ
      if (this.labelSize === 'ss') {
        return 'size-label-ss';
      } else if (this.labelSize === 's') {
        return 'size-label-s';
      } else {
        return 'size-label-m';
      }
    },
    outerWidth: function () {

      if (typeof this.outerSize === 'undefined') {
        return '';
      }

      return 'width: ' + this.outerSize + 'px';
    },
    innerWidth: function () {

      if (typeof this.innerSize === 'undefined') {
        return '';
      }

      return 'min-width: ' + this.innerSize + 'px';
    },
    additionalCss: function () {

      if (!this.isDisable) {
        return 'cursor-pointer';
      } else {
        return '';
      }

    }
  },
  methods: {
    initialize: function () {

      if (typeof this.default !== 'undefined') {
        this.checked = this.default;
      }

      let value = {key: this.name, value: this.checked, call: 'CheckBoxObject:initialize'};

      this.$store.dispatch('formValues/setFormData', value).then();

      // ----------

      if (this.watchCtrlA === null) {
        this.watchCtrlA = this.$store.watch(() => {

          // console.log(this.$store.getters['formValues/formOptionData'](this.name))

          return this.$store.getters['formValues/formOptionData'](this.name);
        }, () => {

          this.statusChange();

        });
      }

      if (this.watchCtrlFV === null) {
        this.watchCtrlFV = this.$store.watch(() => {
          return this.$store.getters['formValues/formValue'](this.name);
        }, () => {

          this.updated();

        });
      }

    },
    updated: function () {

      // console.log('updated', this.name)

      let storeData = this.$store.getters['formValues/formValue'](this.name);

      // console.log('updated', this.name, storeData, this.checked)

      if (this.checked !== storeData) {

        // console.log('updated', this.name)

        this.checked = storeData;

      }
    },
    checkAll: function () {

      // 初期化
      this.checked = [];

      for (let key in this.options) {
        this.checked.push(this.options[key]['value']);
      }

      let value = {key: this.name, value: this.checked, call: 'CheckBoxObject:initialize'};

      this.$store.dispatch('formValues/setFormData', value).then();

      // ステータスクリア
      let option = {'name': this.name, 'type': 'executed'};

      this.$store.dispatch('formValues/setFormOption', option).then();

    },
    clearAll: function () {
      this.checked = [];

      // ステータスクリア
      let option = {'name': this.name, 'type': 'executed'};

      let value = {key: this.name, value: this.checked, call: 'CheckBoxObject:initialize'};

      this.$store.dispatch('formValues/setFormData', value).then();

      this.$store.dispatch('formValues/setFormOption', option).then();

    },
    statusChange: function () {

      let type = this.$store.getters['formValues/formOptionData'](this.name);
      // console.log('statusChange', this.name, type)

      if (type === 'select') {
        this.checkAll();
      } else if (type === 'deselect') {
        this.clearAll();
      }

    },
    checkStatus: function (index) {
      // console.log(this.name, index, this.checked,  typeof this.checked);

      if (typeof this.checked === 'undefined') {
        return false;
      }

      if (this.checked.indexOf(index) >= 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .checkbox-wrapper {
    display: inline-block;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
  }

  .checkbox-container {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    line-height: 32px;
    padding: 0;
  }

  .checkbox-inner {
    display: flex;
  }

  /* チェックボックス */
  .checkbox {
    display: none;
  }

  .checkbox-icon-none,
  .checkbox-icon-checked {
    padding-bottom: 3px;
    display: inline-block;
    text-align: center;
    padding-top: 3px;
  }

  .checkbox-icon-checked {
    color: $frontCheckbox;
  }

  .checkbox-icon-none {
    color: #9b9b9b;
  }

  .label {
    color: #4a4a4a;
  }

  /* :classで利用 */
  .size-label-ss {
    font-size: 10px;
  }

  .size-label-s {
    font-size: 14px;
  }

  .size-label-m {
    font-size: 16px;
  }

  .size-ss {
    line-height: 25px;
    font-size: 15px;
    width: 22px;
  }

  .size-s {
    line-height: 25px;
    font-size: 14px;
    width: 20px;
  }

  .size-m {
    line-height: 30px;
    font-size: 24px;
    width: 30px;
  }

  .inner-label-2row {
    line-height: 15px;
    padding-top: 4px;
    width: 90px;
  }
</style>
